// extracted by mini-css-extract-plugin
export var loadingShimmer = "_qx-2";
export var messageContent = "_qx-0";
export var messagesScroll = "_qx-1";
export var shimmer = "_qx-3";
export var shimmerW100 = "_qx-4";
export var shimmerW70 = "_qx-8";
export var shimmerW80 = "_qx-7";
export var shimmerW85 = "_qx-6";
export var shimmerW90 = "_qx-5";